import React from 'react';
import styled from 'styled-components';
import Image from '../parts/Image';
import { GetShops200ResponseInner } from '../../../api/v1';
import { Link } from "react-router";
import cafectSampleImage from '../../assets/images/cafect_sample.webp';

type ShopCardProp = {
  shop: GetShops200ResponseInner
  link: string
}

const ShopCardStyle = styled(Link)`
  display: block;
  text-decoration: none;

  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }
`;

const ShopNameStyle = styled.p`
  color: #383432;
  font-size: 16px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
`;

const InformationStyle = styled.p`
  color: #6d6a68;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 10px 0 0;
`;

const ShopCard: React.FC<ShopCardProp> = ({ shop, link }) => {
  return (
    <ShopCardStyle key={shop.id} to={ link }>
      <Image src={shop.images[0] ? shop.images[0]?.url : cafectSampleImage} width='100%' alt='店舗画像' />
      <ShopNameStyle>{ shop.name }</ShopNameStyle>
      <InformationStyle>{ shop.address }</InformationStyle>
    </ShopCardStyle>
  );
};

export default ShopCard;
